export default {
    "available_in_your_tariff": "Доступно в вашем тарифе",
    "market": "Маркет",
    "market_of_apps": "Маркет приложений",
    "most_popular_apps": "Самые популярные приложения",
    "new_items": "Новинки",
    "recommended_apps": "Рекомендуемые приложения",
    "setup": "Настроить",
    "submit_an_application": "Подать заявку",
    "your_application_was_submitted_our_manager_will_contact_you_soon": "Ваша заявка отправлена, наш менеджер свяжется с вами в ближайшее время",
}
